/**
 * Created by fanglijuan 2017-5-19
 */
angular.module("typesettingPageManageServiceModule", [
    "productManageMentZPLayoutRankModule"
    ])
    .factory("typesettingPageManageService", ["$modal", "$q", "trsHttpService", "globleParamsSet", function($modal, $q, trsHttpService, globleParamsSet) {
        return {
            ZPLayoutRank: function(type, curpos, selectedArray, array, confirm, cancel) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/ZPLayoutRank/ZPLayoutRank_tpl.html",
                    windowClass: 'zp-layout-rank-window',
                    backdrop: false,
                    controller: "productManageMentZPLayoutRankCtrl",
                    resolve: {
                        params: function() {
                            return {
                                type: type,
                                curpos: curpos,
                                selectedArray: selectedArray,
                                array: array
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            }
        };
    }]);